import React from "react"
import { useTranslation } from "next-i18next"
import uploadImage from "@/components/VisualSearch/v1/UploadImage/uploadImage.module.scss"
import uploadImageForGlobalVS from "@/components/GlobalVisualSearch/UploadImageForGlobalVS/index.module.scss"
import useViewport from "@/hooks/useViewport"
import QRCode from "@/components/VisualSearch/v1/QRCode"
import FileUpload from "@/components/VisualSearch/v1/UploadImage/FileUpload.view"
import UploadImageSection from "@/components/VisualSearch/v1/UploadImage/UploadImageSection.view"
import { getTranslations } from "@/components/VisualSearch/localization"
import {
  BackIconGuide,
  CloseIconGuideNew,
} from "@/components/VisualSearch/v1/UploadImage/icons"

const UploadImage = props => {
  const {
    setImage = () => {},
    category,
    setShowInfo,
    setSection,
    setEventType = () => {},
    setOutput,
    isUsingGlobalVS = false,
  } = props
  const device = useViewport()
  const { t } = useTranslation()
  const { photoGuidelineText } = getTranslations(t)
  const Style = isUsingGlobalVS ? uploadImageForGlobalVS : uploadImage

  return (
    <>
      <div className={Style.UploadImageContainer}>
        <div className="outer-wrapper position-relative visualContentwarpper">
          <FileUpload
            setImage={setImage}
            setSection={setSection}
            setEventType={setEventType}
            category={category}
          />
          {device?.isSmallTabView ? (
            <div className="mobile-wrapper ">
              <div className="close-container d-flex align-items-center justify-content-between">
                <span
                  className="close-Icon"
                  onClick={() => setShowInfo(false)}
                  tabIndex="0"
                  role="button"
                >
                  <BackIconGuide />
                </span>
                <div className="guide-photo d-flex align-items-center justify-content-center flex-1">
                  <p>{photoGuidelineText}</p>
                </div>
                <span
                  className="close-Icon"
                  onClick={() =>
                    setShowInfo ? setShowInfo(false) : setSection("category")
                  }
                  tabIndex="0"
                  role="button"
                >
                  <CloseIconGuideNew />
                </span>
              </div>
            </div>
          ) : null}
          <div
            className={`how-it-works ${
              category === "serviceParts" &&
              "justify-content-start align-items-start pt-50 m-0"
            }`}
          >
            <UploadImageSection category={category} setOutput={setOutput} />
          </div>
        </div>
      </div>
      {!device?.isSmallTabView ? <QRCode /> : null}
    </>
  )
}

export default UploadImage
